import {
	QueryParamConfig,
	UrlUpdateType,
	decodeDelimitedArray,
	encodeDelimitedArray,
	useQueryParam
} from 'use-query-params';
import { CheckboxItem } from 'components/core/checkbox-group';
import { useAppSelector } from 'redux/store';

export const LAW_QUERY_KEY = 'wetgeving';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseLawReturn = {
	selectedLaws: CheckboxItem[];
	selectedLawsParam: string | (string | null)[] | null | undefined;
	setSelectedLawsParam: (
		newValue: NewValueType<CheckboxItem[] | null | undefined>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useLaw = (): UseLawReturn => {
	const { permitLaws } = useAppSelector((state) => state.permits);

	const [selectedLawsParam, setSelectedLawsParam] = useQueryParam(LAW_QUERY_KEY, LawArrayParam);
	const selectedLaws = permitLaws.filter((law) => selectedLawsParam?.includes(String(law.id)));

	return {
		selectedLaws: selectedLaws.map((law) => ({
			id: law.id,
			label: law.name
		})),
		selectedLawsParam,
		setSelectedLawsParam
	};
};

export const LawArrayParam: QueryParamConfig<
	CheckboxItem[] | null | undefined,
	string | (string | null)[] | null | undefined
> = {
	encode: (array) => {
		if (array == null) {
			return undefined;
		}

		const permitLaws = array.filter(Boolean).map((checkboxItem) => String(checkboxItem.id));
		const value = permitLaws.length > 0 ? permitLaws : null;
		return encodeDelimitedArray(value);
	},
	decode: (param) => {
		return decodeDelimitedArray(param);
	}
};
